<template>
  <div class="pa-2" style="min-height: 900px; height: 100%">
    <!-- انتخاب نوع QR -->
    <v-card style="display: flex; align-items: center; justify-content: center">
      <v-col class="pa-2 justify-center" cols="12">
        <qr-type-card @selectQr="selectQr" />
      </v-col>
    </v-card>

    <div v-if="selectedType" class="mt-8">
      <cardvisit-auto v-if="selectedType.toLowerCase() === 'visitcard'" />
      <productlabel-auto v-if="selectedType.toLowerCase() === 'labelproduct'" />
      <product-auto v-if="selectedType.toLowerCase() === 'singleproduct'" />
    </div>
  </div>
</template>

<script>
import QrTypeCard from "./QrTypeCard.vue";
import productlabelAuto from "./productlabelAuto.vue";
import cardvisitAuto from "./cardvisitAuto.vue";
import productAuto from "./productAuto.vue";

export default {
  name: "MainPage",

  components: {
    QrTypeCard,
    cardvisitAuto,
    productlabelAuto,
    productAuto,
  },

  data() {
    return {
      selectedType: "",
    };
  },

  methods: {
    selectQr(type) {
      this.selectedType = type;
    },
  },
};
</script>

<style scoped></style>
